import React, { FC } from 'react';
import { ConfigProvider } from 'antd';
import styled from 'styled-components';
import { useLocation } from 'react-router';
import { useIsMobile } from '~/hooks/useScreenSizes';
import { Scrollbars } from '~/components';
import { getLayoutHeight, SOBLayoutHeight, useHeaderHeight } from '~/hooks/useHeaderHeight';
import { useDirection } from '~/hooks/i18nHooks';
import Header from './Header';
import WizardContentContainer from './WizardContentContainer';
import backgroundImagePath from '../../img/Background_pages.png';

const WizardLayout: any = (props: any) => {
  const { children } = props;
  // useGetValidationJs();
  const dir = useDirection();
  const location = useLocation();
  const headerHeight = useHeaderHeight({ wizardHeader: true });
  const isServices = location.pathname === '/wizard/services' || location.pathname === '/ksa/products';
  const isMobile = useIsMobile();
  const isKsaPage = location.pathname === '/ksa/';

  return (
    <ConfigProvider componentSize="large">
      <Container isMobile={isMobile} isServices={isServices} className="WizardLayout">
        <Header
          isServices={isServices}
        // middleContent={<WizardTopNavigation isServices={isServices} />}
        // tabletContent={isServicesOrPayment ? <TotalPriceMobileModule /> : <></>}
        />
        <Scrollbars style={SOBLayoutHeight(headerHeight, isMobile, isKsaPage)}>
          <div className="WizardLayout-Wrapper" style={{ minHeight: '100%' }} dir={dir}>
            <WizardContentContainer>{children}</WizardContentContainer>
          </div>
        </Scrollbars>
      </Container>
    </ConfigProvider>
  );
};

const Container = styled.div<any>`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100vh;        /* exact viewport height — prevents outer/window scroll */
  max-height: 100vh;
  overflow: hidden;     /* all scrolling must go through the inner <Scrollbars> only */
  min-width: 100vw;
  ${({ isMobile, isServices }) => `
    ${isMobile
      ? isServices
        ? `
          background: #C5E4F9;
          background-image: none;
        `
        : `
          background: #F6F7F9;
          box-shadow: 0 4px 110px 0 rgba(0, 0, 0, 0.15);
          background-image: none;
        `
      : `
        background-image: url(${backgroundImagePath});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-attachment: fixed;
      `
    }
  `}
  .WizardLayout-Wrapper {
    display: flex;
    flex: 1;
    justify-content: center;
  }
`;

export default WizardLayout;
